module.exports = __webpack_public_path__ + "static/media/background_half.d82194c7.jpg";